var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankNach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 27.1914C12.4004 27.1914 12.4004 34.0354 12.4004 42.1774C12.4004 50.3194 12.4004 56.6914 12.4004 56.6914",
    stroke: "#9852FE",
    strokeWidth: 5.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.998 27.1914C35.998 27.1914 35.998 34.0354 35.998 42.1774C35.998 50.3194 35.998 56.6914 35.998 56.6914",
    stroke: "#9852FE",
    strokeWidth: 5.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6006 27.1914C59.6006 27.1914 59.6006 34.0354 59.6006 42.1774C59.6006 50.3194 59.6006 56.6914 59.6006 56.6914",
    stroke: "#9852FE",
    strokeWidth: 5.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54688 27.1977L35.9969 3.59766L68.4469 27.1977H3.54688Z",
    stroke: "#2B2E6A",
    strokeWidth: 5.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4469 68.4914H3.54688V62.5914C3.54688 59.3317 6.18713 56.6914 9.44688 56.6914H62.5469C65.8066 56.6914 68.4469 59.3317 68.4469 62.5914V68.4914Z",
    stroke: "#2B2E6A",
    strokeWidth: 5.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNach);
export default __webpack_public_path__ + "static/media/bankNach.3b60e26cd3447cd002ba957c76aa26ee.svg";
export { ForwardRef as ReactComponent };